import { FAQsItem } from '@mygpt/app/faqs/services/list';
import { Http } from '@mygpt/app/http';
import { I18N_LANG_MAP } from '@mygpt/app/chat/constant';

interface SearchParams {
  // ai ID 或 dataset ID
  aiId?: string;
  datasetId?: string;
  question: string;
  answer?: string;
  sources?: string;
  excel_id?: string;
  language: string;
  score?: number;
}

/**
 * 获取机器人问答列表
 * @param params
 * @returns
 */
export const faqsSearchListFromDatasetsService = (params: SearchParams, controller?: AbortController) => {
  const { datasetId, language, ...rest } = params;
  const { post } = Http.use();
  return post<FAQsItem[]>(
    `/datasets/${datasetId}/faqs/search-list`,
    {
      ...rest,
      language: I18N_LANG_MAP[language],
    },
    {
      signal: controller?.signal,
    }
  );
};
